import React, { useEffect, useState } from 'react'
import api from '../api/api';
import ClearIcon from '@mui/icons-material/Clear';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const Filtermodal = ({isOpen,onclosemodal,preAppointments,
    setIsRequested,
     isRequested,
  checkLoca,handlePreappointment,handleCheckMethodClick,checkSta, onclearfilters, onapplyfilters,   checkMethod, handleCheckLocaClick,handleCheckStaClick}) => {
  const practiseid = window.getPracticeId();

    const [PaymentMethod, setPaymentMethod] = useState([]);
  const [loading, setLoading] = useState(false); 
 const paymentprev = useSelector(
            (state) => state.userPrivileges.Payment
          );
    const fetchCardData = async () => {
      setLoading(true); // Start loading
      try {
        const response = await api.get(`/v1/${practiseid}/payments/payment-methods`);
        if (response.status === 200) {
          setPaymentMethod(response.data);
        } else {
          setPaymentMethod([]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // Stop loading
      }
    };
  
    useEffect(() => {
      if (isOpen) {
        fetchCardData();
      }
    }, [isOpen]);


  
    if(!isOpen)return null

  return (

    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg md:w-[33%] lg:w-[33%] w-[80%]">
      <div className="w-full justify-between flex border-b mb-2">
          <h2 className="text-[16px] font-semibold text-[#09090B]">Filter Reports</h2>
          <ClearIcon className='cursor-pointer' onClick={onclosemodal} />
        </div>

    <div>
        {/* <div className='flex w-full'>
            <div   onClick={() => handlePreappointment('p')}
         className={`cursor-pointer py-2 px-4 my-3 rounded-full text-sm font-inter 
        ${preAppointments === 'p' 
          ? 'bg-[#FFF7ED] text-[#EA580C]' 
          : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}>
                Previous Appointments
            </div>
        </div> */}
<div className="flex flex-col gap-2">
<div className='font-semibold text-[14px] text-[#71717A]  text-left'>Payment Method</div>
<div className='flex flex-wrap gap-3'>
{loading ? (
    <div className='flex'>
    {  Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            className="rounded-full py-2 mx-2 px-4 w-[40px] h-[30px]"
          />
  
        ))}
    </div>
  ) : (
    PaymentMethod.map((payment) => (
      <button
        key={payment.id}
        value={payment.id}
        onClick={()=>handleCheckMethodClick(payment.id)}
        className={ `cursor-pointer px-4 py-2 my-1 rounded-full  text-xs font-inter ${checkMethod.includes(payment.id) ? 'bg-[#FFF7ED] text-[#EA580C]' : ' border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
      >
        {payment.method}
      </button>
    ))
  )}
   <button
        onClick={()=>handleCheckMethodClick(6)}
        className={ `cursor-pointer px-4 py-2 my-1 rounded-full  text-xs font-inter ${checkMethod.includes(6) ? 'bg-[#FFF7ED] text-[#EA580C]' : ' border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
      >
   CREDIT/DEBIT CARD
      </button>
</div>

</div>
<div className='flex flex-col my-2 '>
  <div className='font-semibold text-[14px] text-[#71717A] text-left my-1'>Payment Location</div>
  <div className='w-full gap-2  flex flex-wrap justify-start'>
    <button
      className={ `cursor-pointer px-4 py-2 my-1 rounded-full  text-xs font-inter  ${checkLoca.includes('front')? 'bg-[#FFF7ED] text-[#EA580C]' : ' border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
      onClick={() => handleCheckLocaClick('front')}
    >
      Front Desk
    </button>
  
    <button
      className={`cursor-pointer px-4 py-2 my-1 rounded-full  text-xs font-inter  ${checkLoca.includes('kiosk') ? 'bg-[#FFF7ED] text-[#EA580C]' : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
      onClick={() => handleCheckLocaClick('kiosk')}
    >
      Kiosk
    </button>

    <button
      className={`cursor-pointer px-4 py-2 my-1 rounded-full  text-sm font-inter  ${checkLoca.includes('online') ? 'bg-[#FFF7ED] text-[#EA580C]' : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
      onClick={() => handleCheckLocaClick('online')}
    >
      Online Check In / Patient App
    </button>
  </div>
</div>


<div className='flex flex-col my-2'>
<div className='font-semibold text-[14px] text-[#71717A]  text-left'>Payment Status</div>
<div className=' flex justify-start gap-2'>
<button       className={`cursor-pointer py-2 my-1 rounded-full  text-sm font-inter w-[100px] ${checkSta.includes('success') ? 'bg-[#FFF7ED] text-[#EA580C]' : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
 onClick={() => handleCheckStaClick('success')}>Success</button>
<div       className={`cursor-pointer py-2 my-1 rounded-full  text-sm font-inter w-[100px] ${checkSta.includes('unsuccess') ? 'bg-[#FFF7ED] text-[#EA580C]' : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
 onClick={() => handleCheckStaClick('unsuccess')}>Unsuccess</div>   
    </div>

</div>
{paymentprev.includes('Delete Payment')?<><div className='flex flex-col my-2'>
<div className='font-semibold text-[14px] text-[#71717A]  text-left'>Deleted Requests</div>
<div className=' flex justify-start gap-2'>
<button       className={`cursor-pointer py-2 my-1 rounded-full  text-sm font-inter px-4 ${isRequested? 'bg-[#FFF7ED] text-[#EA580C]' : 'border-[1.5px] bg-[#F4F4F5] border-gray-200'}`}
 onClick={() => setIsRequested((prev) => !prev)}>Delete Requests</button>

    </div>

</div></>:<></>}
<div className='border-t px-2 py-2 flex pt-3 justify-end'>
 <button onClick={onclearfilters} className='border-[1.5px] border-gray-200 px-2 py-2 text-[13px] font-inter rounded'>
   Clear ALL
 </button>
 <button onClick={onapplyfilters} className='bg-[black] ml-2 text-white px-4 py-2 text-[13px] font-inter rounded'>
    Apply Filter
 </button>
</div>
    </div>
       </div>
    </div>
  )
}

export default Filtermodal
